module.exports = __webpack_public_path__ + "static/media/wm1.33d64ce2.png";